require('./binaryCondition.i18n.json');
require('./binaryCondition.tpl.html');
require('./binaryConditionController.js');

const BinaryConditionComponent = {
    templateUrl: '/common/rule/ruleCondition/binaryCondition/binaryCondition.tpl.html',
    controller: 'binaryConditionController',
    bindings: {
        ruleCondition: '<',
        canUserManageFormRules: '<',
        defaultFormTemplateUniqueName:'<'
    }
};

angular.module('ums')
    .component('uiBinaryCondition', BinaryConditionComponent);
